import {Formatters, Messages} from '../../codegen/Localize';
import {openReactConfirmationDialog} from '../../commonInfra/dialogs/ReactConfirmationDialog';
import {TabDialogWidth} from '../../commonInfra/dialogs/style/TabDialogWidth';
import {IResult} from '../../httpClient/serverApi/types/IResponse';
import {Set} from '../../ts/models/Set';
import {IServerUser} from '../../ts/ServerApi/types/IServerUser';
import {ISiteUser} from '../../ts/ServerApi/types/ISiteUser';
import {IUser} from '../../ts/ServerApi/types/IUser';
import {IUserActionResult, UserActionResultCode} from '../../ts/ServerApi/types/IUserActionResult';
import {
  UserActionNotification,
  UserActionNotificationParams
} from '../../userManagement/services/notifications/UserActionNotification';
import {ServerUsers} from '../../userManagement/services/resources/ServerUsers';


export function forcePasswordUpdateOnSiteUsers(siteUsers: Set<ISiteUser>): Promise<any> {
  return forcePasswordUpdate(siteUsers,
    ServerUsers.instance.forcePasswordUpdateOnSiteUsers.bind(ServerUsers.instance));
}

export function forcePasswordUpdateOnServerUsers(serverUsers: Set<IServerUser>): Promise<any> {
  return forcePasswordUpdate(serverUsers,
    ServerUsers.instance.forcePasswordUpdate.bind(ServerUsers.instance));
}

function forcePasswordUpdate(users: Set<IUser>,
                             requestTrigger: (userIds: string[]) => Promise<IUserActionResult>): Promise<any> {
  const dialogBody = Messages.confirmForcePasswordUpdate({
    USER_COUNT: users.size(),
    USER_COUNT_LOC: Formatters.formatCount(users.size())
  });

  const dialogInstance = openReactConfirmationDialog<void, IResult>({
    title: Messages.forcePasswordUpdateTitle(),
    message: dialogBody,
    paramsForAction: undefined,
    action: () => requestTrigger(users.keys()),
    actionName: Messages.confirmForcePasswordUpdateButton({
      ITEM_COUNT: users.size(),
      ITEM_COUNT_LOC: Formatters.formatCount(users.size())
    }),
    isActionDelete: false,
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IUserActionResult) => {
    const params: UserActionNotificationParams = {
      users: users,
      results: result.results,
      errors: result.errors,
      successCode: UserActionResultCode.userForcedPasswordUpdate,
    };
    UserActionNotification.instance.notify(params);
  });
  return Promise.resolve(dialogInstance.result);
}